export function clientRateToForm(rate) {
    let cleanedRate = Object.assign({}, rate);

    if (cleanedRate.client !== undefined && cleanedRate.client.id !== undefined) {
        cleanedRate.client = cleanedRate.client.id;
    }

    return cleanedRate;
}

export function clientRatesToSelect(rates) {
    let cleanedRates = [];

    rates.map((item) => (
        cleanedRates.push({
            label: item.name + " (" + item.rate + "%)",
            value: item.id,
            item: item,
        })
    ));
    return cleanedRates;
}


// WEBPACK FOOTER //
// ./src/utils/clientRate.js